import {
 FETCH_MATCHES_REQUESTED,
 FETCH_MATCHES_SUCCESS,
 FETCH_MATCHES_FAILURE,
 ADD_MATCH_REQUESTED,
 ADD_MATCH_SUCCESS,
 ADD_MATCH_FAILURE,
} from 'constants/actions'

import {
  fetchMatches as fetchMatchesRequest,
  addMatch as addMatchRequest,
} from 'api/requests'

export const getMatches = (params) => async (dispatch) => {
  dispatch({
    type: FETCH_MATCHES_REQUESTED,
  })

  try {
    const response = await fetchMatchesRequest(params)

    const responseData = response.data

    if (responseData) {
      dispatch({
        type: FETCH_MATCHES_SUCCESS,
        data: {
          matches: responseData,
        },
      })
    }
  } catch (error) {
    dispatch({
      type: FETCH_MATCHES_FAILURE,
      data: { message: error.response?.data?.error || 'Failed to load matches.' },
    })
  }
}

export const addMatch = (matchParams) => async (dispatch) => {
  dispatch({
    type: ADD_MATCH_REQUESTED,
  })

  try {
    const response = await addMatchRequest(matchParams)

    const responseData = response.data

    if (responseData) {
      dispatch({
        type: ADD_MATCH_SUCCESS,
        data: {
          matches: responseData,
        },
      })

      return response
    }
  } catch (error) {
    dispatch({
      type: ADD_MATCH_FAILURE,
      data: { message: error.response?.data?.error || 'Failed to add match.' },
    })
  }
}
